import TooltipOptions from 'primereact/tooltip/tooltipoptions';

export const defaultTooltipOptions: TooltipOptions = {
  autoHide: true,
  position: 'top',
  showDelay: 500,
};
